import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Autoplay, Grid, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initInformationCardsGrid() {
  Alpine.data(
    'informationCardsGrid',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.swiper-information-cards-grid');
        if (swiperEl) {
          this.initSwiper(swiperEl as HTMLElement);
        }
      },
      initSwiper(domEl) {
        const { size } = domEl.dataset;
        const sizeNum = Number(size);
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation, Grid],
          spaceBetween: 20,
          slidesPerView: 2,
          grid: {
            rows: sizeNum < 3 ? 1 : 2,
            fill: sizeNum < 3 ? 'row' : 'column',
          },
          navigation: {
            nextEl: '.swiper-information-cards__buttons .swiper-button-next',
            prevEl: '.swiper-information-cards__buttons .swiper-button-prev',
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
            },
            320: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1,
              grid: {
                rows: 2,
              },
            },
            992: {
              slidesPerView: 2,
              grid: {
                rows: 2,
              },
            },
          },
        });
      },
    }),
  );
}
